import { HTTP_TOKEN } from "./http";

export const generateSSOCanny = data => {
  return HTTP_TOKEN.post("integration/external/canny", data).then(result => {
    return result.data;
  });
};
